import { useEffect, useState } from "react";
import CCService from "../../services/httpServiceWithoutSuperAdmin";
import VenueForm from "./VenueForm";
import { Modal } from "@mui/material";
import { Edit } from "@mui/icons-material";

export default function VenuesPage() {
  const services = new CCService();
  const [venues, setVenues] = useState([]);
  const [open, setOpen] = useState(false);
  const [columns, setColumns] = useState(1);
  const [selectedVenue, setSelectedVenue] = useState(null);
  // responsive columns: <768 => 1, <1024 => 2, else 3
  useEffect(() => {
    function updateCols() {
      const w = window.innerWidth;
      if (w < 768) setColumns(1);
      else if (w < 1024) setColumns(2);
      else setColumns(3);
    }
    updateCols();
    window.addEventListener("resize", updateCols);
    return () => window.removeEventListener("resize", updateCols);
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await services.get("/ahead/admin/event-venues");
        // support different shapes
        const payload = response?.data ?? response;
        if (Array.isArray(payload)) setVenues(payload);
        else if (Array.isArray(payload?.items)) setVenues(payload.items);
        else setVenues([]);
      } catch (error) {
        console.error("Error fetching venues:", error);
      }
    };

    fetchEvents();
  }, []);

  const styles = {
    page: {
      padding: 16,
      fontFamily:
        "Inter, Roboto, system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Arial",
      boxSizing: "border-box",
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 16,
    },
    title: { fontSize: 20, fontWeight: 700, margin: 0 },
    newBtn: {
      backgroundColor: "#4F46E5",
      color: "#fff",
      padding: "8px 14px",
      borderRadius: 8,
      border: "none",
      cursor: "pointer",
      fontWeight: 600,
      boxShadow: "0 4px 10px rgba(79,70,229,0.12)",
    },
    grid: {
      display: "grid",
      gap: 16,
    },
    card: {
      position: "relative",
      padding: 16,
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
      transition: "box-shadow 160ms ease, transform 120ms ease",
      cursor: "default",
    },
    cardHover: {
      boxShadow: "0 6px 18px rgba(15,23,42,0.12)",
      transform: "translateY(-4px)",
    },
    cardTitle: { fontSize: 16, fontWeight: 600, margin: 0 },
    cardMeta: { fontSize: 13, color: "#4B5563", marginTop: 8 },
    cardSmall: { fontSize: 12, color: "#6B7280", marginTop: 6 },
    modalWrapper: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      background: "#fff",
      borderRadius: 10,
      padding: 20,
      width: "90vw",
      maxWidth: 600,
      boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
      outline: "none",
      maxHeight: "90vh",
      overflowY: "auto",
    },
    empty: { padding: 20, color: "#6B7280", textAlign: "center" },
  };

  const handleEdit = (v) => {
    setSelectedVenue(v);
    setOpen(true);
  };

  useEffect(() => {
    if (!open) {
      setSelectedVenue(null);
    }
  }, [open]);
  return (
    <div style={styles.page}>
      <div style={styles.headerRow}>
        <h1 style={styles.title}>Venues</h1>
        <button onClick={() => setOpen(true)} style={styles.newBtn}>
          + Add Venue
        </button>
      </div>

      {venues.length === 0 ? (
        <div style={styles.empty}>No venues found.</div>
      ) : (
        <div
          style={{
            ...styles.grid,
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
          }}
        >
          {venues.map((v) => (
            <div
              key={v.id}
              style={styles.card}
              onMouseEnter={(e) =>
                Object.assign(e.currentTarget.style, {
                  boxShadow: styles.cardHover.boxShadow,
                  transform: styles.cardHover.transform,
                })
              }
              onMouseLeave={(e) =>
                Object.assign(e.currentTarget.style, {
                  boxShadow: styles.card.boxShadow,
                  transform: "none",
                })
              }
              onClick={() => handleEdit(v)}
            >
              <div style={{ position: "absolute", top: 6, right: 6 }}>
                <Edit />
              </div>
              <h3 style={styles.cardTitle}>{v.name ?? "—"}</h3>
              <p style={styles.cardMeta}>
                {v.city ?? "—"}
                {v.state ? `, ${v.state}` : ""}
              </p>
              <p style={styles.cardSmall}>Cap: {v.capacity ?? "—"}</p>
            </div>
          ))}
        </div>
      )}

      <Modal open={open} onClose={() => setOpen(false)}>
        <div style={styles.modalWrapper}>
          <VenueForm
            initialData={selectedVenue}
            onSuccess={(data, type) => {
              if (type === "post") {
                setVenues((prev) => [...prev, data]);
                setOpen(false);
              } else {
                setVenues((prev) =>
                  prev.map((v) => (v.id === data.id ? data : v))
                );
                setOpen(false);
              }
            }}
          />
        </div>
      </Modal>
    </div>
  );
}
